import React from "react";

export default function ItemTime({
  prettyTime,
  currentTimeInMinutes,
  itemTimeInMinutes,
  isToday,
  itemType,
}) {
  let className = "item-time";
  if (isToday && itemTimeInMinutes - 60 < currentTimeInMinutes) {
    className += " happening";
  }
  if (itemType === "task") {
    className += " deadline";
  }
  const digits = prettyTime.slice(0, prettyTime.length - 1);

  const meridiem = prettyTime.slice(prettyTime.length - 1, prettyTime.length);
  return (
    <div className="item-time-wrapper">
      <div className={className}>
        <span className="digits-outer-wrapper">
          <span className="digits">{digits}</span>
          <span className="digit-inputs-border-bottom" />
        </span>
        <span className="meridiem">{meridiem}</span>
      </div>
    </div>
  );
}
